import React from 'react'
import { InputSelect } from 'AtomicComponents'

class Select extends React.Component {
  _handleChange = (value) => {
    const { options } = this.props
    const index = options.findIndex(item => item.name === value)
    const { onChange = () => {} } = this.props
    onChange(options[index], index)
  }
  render (){
    const { options } = this.props
    return (
      <InputSelect
        {...this.props}
        required
        withoutStar
        onChange={this._handleChange}
        options={options.map((item)=>{
          item.value = item.label || item.name
          item.label = item.label || item.name
          return item;
        })}
      />
    )
  }
}

export default Select



// WEBPACK FOOTER //
// ./src/components/form-elements/select/index.jsx